import { t } from 'i18next';
import React from 'react'
import { Card } from "react-bootstrap"
import '../../../../styles/css/RelatedConcept.css'

function RelatedConceptCard(props) {

    //Parametros de entrada.
    const inputParam_RelatedConceptType = props.relatedConceptType;
    const inputParam_SelectedItemTypeId = props.selectedItemTypeId;
    const inputParam_SetterSelectedRelatedConceptType = props.setSelectedRelatedConceptType;
    const inputParam_Setter = props.set;
    const inputParam_EditMode = props.editMode !== null && props.editMode !== undefined ? props.editMode : false;
    const inputParam_UserHasConfigRoleAction = props.userHasConfigRoleAction !== null && props.userHasConfigRoleAction !== undefined ? props.userHasConfigRoleAction : false;

    return (
        <>
        {
            inputParam_EditMode && inputParam_UserHasConfigRoleAction &&
            <Card className="h-100" onClick={ () => inputParam_SetterSelectedRelatedConceptType(inputParam_RelatedConceptType.id, inputParam_Setter) }>
                <Card.Body className={`cursor-pointer card-related-concept ${inputParam_SelectedItemTypeId === inputParam_RelatedConceptType.id ? "card-related-concept-checked" : ""}`}>
                    <div className="card-related-concept-title">
                        <h5>
                            { t(inputParam_RelatedConceptType.text) }
                        </h5>
                    </div>
                </Card.Body>
            </Card>
        }
        {
            !inputParam_EditMode &&
            <Card className="h-100">
                <Card.Body className={`card-related-concept ${inputParam_SelectedItemTypeId === inputParam_RelatedConceptType.id ? "card-related-concept-checked" : ""}`}>
                    <div className="card-related-concept-title">
                        <h5>
                            { t(inputParam_RelatedConceptType.text) }
                        </h5>
                    </div>
                </Card.Body>
            </Card>
        }
        </>
    );
}

export default RelatedConceptCard;